import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useFetchSearchAssistantByIdNoCacheMutation } from '@redux/api'
import { useFetchRestrictionsMutation } from '@redux/api/restriction.api'
import { useLazyFetchSearchAssistantByIdQuery } from '@redux/api/searchAssistant.api'
import { useLazyFetchEnrichedTimeLineConfigByIdQuery } from '@redux/api/timeline.api'

import { getLocalStorageContext } from '@helpers'
import { TimeLineDTOType } from '@types'

import { SearchAssistant } from '../../../types/searchAssistant'
import { enrichConfigWithDefaultValues } from '../helpers'

export const useConfig = () => {
  const { id: timeLineId } = useParams()
  const [timeLineConfig, setTimeLineConfig] = useState<TimeLineDTOType | null>(null)
  const [searchAssistantConfig, setSearchAssistantConfig] = useState<SearchAssistant | undefined>(
    undefined
  )
  const [isLoadingSearchAssistantConfig, setIsLoadingSearchAssistantConfig] = useState(true)
  const [fetchTimeLine, { isFetching: timeLineLoading }] =
    useLazyFetchEnrichedTimeLineConfigByIdQuery()

  const [
    fetchObjectYRestrictions,
    { isLoading: isLoadingObjectYInitialRestrictions, data: objectYInitialRestrictions },
  ] = useFetchRestrictionsMutation()
  const [
    fetchObjectXRestrictions,
    { isLoading: isLoadingObjectXInitialRestrictions, data: objectXInitialRestrictions },
  ] = useFetchRestrictionsMutation()

  const context = getLocalStorageContext()

  const [fetchSearchAssistantConfigByContextId] = useFetchSearchAssistantByIdNoCacheMutation()
  const [fetchSearchAssistantConfigById] = useLazyFetchSearchAssistantByIdQuery()

  useEffect(() => {
    if (timeLineId) {
      fetchTimeLine(timeLineId)
        .unwrap()
        .then(resp => {
          if (resp) {
            if (resp.objectX?.entityId) {
              fetchObjectXRestrictions({ viewId: resp.objectX.entityId })
            }

            if (resp.objectY?.entityId) {
              fetchObjectYRestrictions({ viewId: resp.objectY.entityId })
            }

            if (resp.searchAssistantId) {
              fetchSearchAssistantConfigById({ id: resp.searchAssistantId })
                .unwrap()
                .then(config => {
                  setSearchAssistantConfig(config)
                })
                .finally(() => setIsLoadingSearchAssistantConfig(false))
            }

            if (context?.id && !resp.searchAssistantId) {
              fetchSearchAssistantConfigByContextId({ id: context?.id })
                .unwrap()
                .then(config => {
                  setSearchAssistantConfig(config)
                })
                .finally(() => setIsLoadingSearchAssistantConfig(false))
            }

            setTimeLineConfig(enrichConfigWithDefaultValues(resp))
          }
        })
    }
  }, [timeLineId])

  return {
    config: timeLineConfig,
    searchAssistantConfig,
    isLoadingSearchAssistantConfig,
    timeLineLoading,
    objectYInitialRestrictions,
    objectXInitialRestrictions,
    isLoadingObjectXInitialRestrictions,
    isLoadingObjectYInitialRestrictions,
  }
}
